// extracted by mini-css-extract-plugin
export default {"wrapper":"keywords_suggest-module__wrapper--2Byoc","title":"keywords_suggest-module__title--1qgH5"};